<template>
  <div class="d-flex justify-center align-center">
    <v-progress-circular
      :color="color"
      indeterminate
      :size="size"
      class="mr-2"
    />
    <span class="text-font">
      {{ message }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

withDefaults(defineProps<{
  color?: string;
  message?: string;
  size?: number;
}>(), {
  color: () => 'primary',
  message: () => useI18n().t('states.loading'),
});
</script>
